import Reveal from "@/components/Reveal";

const breaks = [
  {
    index: "01",
    title: "Knowledge gap",
    copy: "An offer, pricing or availability question remains unresolved while the buyer is deciding.",
  },
  {
    index: "02",
    title: "Compliance miss",
    copy: "The rep misses required wording or uses information that the organisation has not approved.",
  },
  {
    index: "03",
    title: "Context lost",
    copy: "Buyer intent, commitments and next steps stay buried in the conversation.",
  },
];

export default function Problem() {
  return (
    <section className="problem" id="product" data-testid="problem-section">
      <div className="wrap">
        <div className="problem-top">
          <div>
            <div className="label mono">The missing layer</div>
            <h2 className="section-title">The funnel breaks inside the sales call</h2>
          </div>
          <p className="section-copy">
            Marketing creates demand. The call decides whether that demand becomes revenue. Yet the
            rep still enters the most important moment with scattered context, delayed answers and
            manual follow-through.
          </p>
        </div>
        <Reveal className="breaks">
          {breaks.map((b) => (
            <article className="break" key={b.index} data-testid={`break-${b.index}`}>
              <span className="break-index">{b.index}</span>
              <h3>{b.title}</h3>
              <p>{b.copy}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
